import { render, staticRenderFns } from "./EditEndereco.vue?vue&type=template&id=04ba7958"
import script from "./EditEndereco.vue?vue&type=script&lang=js"
export * from "./EditEndereco.vue?vue&type=script&lang=js"
import style0 from "./EditEndereco.vue?vue&type=style&index=0&id=04ba7958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports